import {BASE_API_URL} from 'api/config';
import { createPublicAxios } from './../axios';

const publicSettingsApi = createPublicAxios({
    baseURL: BASE_API_URL + '/public/settings',
});

export const getPublicSetting = (params) => {
    return publicSettingsApi.get(`/search`, {params});
}